import { render, staticRenderFns } from "./PartCard.vue?vue&type=template&id=2841e982"
import script from "./PartCard.vue?vue&type=script&lang=js"
export * from "./PartCard.vue?vue&type=script&lang=js"
import style0 from "./PartCard.vue?vue&type=style&index=0&id=2841e982&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports